module.exports = __webpack_public_path__ + "img/sp_fill.57193056.svg";